import { render } from "./BalanceCard.vue?vue&type=template&id=9bc3806e&ts=true"
import script from "./BalanceCard.vue?vue&type=script&lang=ts"
export * from "./BalanceCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__